import React from 'react';
import { Helmet } from 'react-helmet';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';

import useTheme from './useTheme';

import Navigation from '../Navigation';

  
const Layout = ({
  siteUrl,
  title,
  tagline,
  description,
  shareImage,
  shareImageWidth,
  shareImageHeight,
  pathname,
  noindex,
  logoBlack,
  logoWhite,
  pages,
  children,
  footer,
}) => {

  return (
    <ThemeProvider theme={useTheme()}>
      <CssBaseline />
      <Box sx={{ backgroundColor: 'background.default' }}>
        <Helmet>
          <meta charSet="utf-8" />

          <title>{title}</title>

          <meta
            name="title"
            content={`${title}`}
          />
          <meta
            name="description"
            content={description}
          />
          <meta name="author" content="Jonas Piela" />
          <meta name="image" content={shareImage} />

          <meta
            property="og:title"
            content={title}
          />
          <meta
            property="og:description"
            content={description}
          />
          <meta property="article:author" content="Jonas Piela" />
          <meta property="og:type" content="website" />
          <meta
            property="og:image"
            content={`${siteUrl}${shareImage}`}
          />
          <meta
            property="og:image:width"
            content={shareImageWidth || '1200'}
          />
          <meta
            property="og:image:height"
            content={shareImageHeight || '628'}
          />
          <meta
            property="og:description"
            content={description}
          />
          <meta property="og:url" content={`${siteUrl}${pathname}`} />

          <link
            rel="alternate"
            type="application/rss+xml"
            title="Digital Insurance Podcast"
            href="https://podcast-admin.firebaseapp.com/feed/2T9aVqEJhvd1Fck2vVPp/"
          />

          {noindex ? (
            <meta name="robots" content="noindex, nofollow" />
          ) : (
            ''
          )}

          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
        <Navigation
          logoBlack={logoBlack}
          logoWhite={logoWhite}
          siteUrl={siteUrl}
          pages={pages}
        />
        {children}
        {footer}
      </Box>
    </ThemeProvider>
  );
};

export default Layout;
